export default __webpack_public_path__ + "static/media/ic_manage-packages.dc962b5d.svg";